import { cn } from '../../lib/utils';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'info' | 'default' | 'outline';
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'gray' | 'purple' | 'pink';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Badge({
  children,
  variant = 'default',
  color,
  size = 'md',
  className
}: BadgeProps) {
  const variants = {
    default: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    success: 'bg-success-100 text-success-700 dark:bg-success-900/40 dark:text-success-300',
    warning: 'bg-warning-100 text-warning-700 dark:bg-warning-900/40 dark:text-warning-300',
    error: 'bg-error-100 text-error-700 dark:bg-error-900/40 dark:text-error-300',
    info: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
    outline: 'bg-transparent border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400',
  };

  const colors = {
    blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
    green: 'bg-success-100 text-success-700 dark:bg-success-900/40 dark:text-success-300',
    yellow: 'bg-warning-100 text-warning-700 dark:bg-warning-900/40 dark:text-warning-300',
    red: 'bg-error-100 text-error-700 dark:bg-error-900/40 dark:text-error-300',
    gray: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    purple: 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
    pink: 'bg-pink-100 text-pink-700 dark:bg-pink-900/40 dark:text-pink-300',
  };

  const sizes = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-xs px-2.5 py-1 leading-4',
    lg: 'text-sm px-3 py-1.5',
  };

  const badgeColor = color ? colors[color] : variants[variant];

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        badgeColor,
        sizes[size],
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
